import { GraphComponentsModule } from './graph-components.module';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { GraphsMainComponent } from './graphs-main.component';
import { ProgramsComponent } from './programs/programs.component';
import { TargetsComponent } from './targets/targets.component';
import { GraphsRoutingModule } from './graphs.routing.module';

import { NgApexchartsModule } from 'ng-apexcharts';
import { BehaviorsComponent } from './behaviors/behaviors.component';
import { AnnotationsComponent } from './annotations/annotations.component';
import { AnnotationComponent } from './annotations/annotation/annotation.component';
import { ProgramGraphComponent } from './programs/program-graph/program-graph.component';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { MixedComponent } from './mixed/mixed.component';
import { MixedGraphComponent } from './mixed/mixed-graph/mixed-graph.component';

const pages = [GraphsMainComponent, ProgramsComponent, TargetsComponent];

@NgModule({
  exports: [GraphComponentsModule],
  declarations: [
    ...pages,
    BehaviorsComponent,
    AnnotationsComponent,
    AnnotationComponent,
    ProgramGraphComponent,
    MixedComponent,
    MixedGraphComponent,
  ],
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    GraphsRoutingModule,
    GraphComponentsModule,
    NgApexchartsModule,
    OverlayPanelModule,
    TableModule,
    ButtonModule,
    MultiSelectModule,
    DropdownModule,
  ],
})
export class GraphsModule {
  constructor(@Optional() @SkipSelf() parentModule: GraphsModule) {
    if (parentModule) {
      throw new Error(
        'Module is already loaded. Import in your base AppModule only.'
      );
    }
  }
}
